var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-back",on:{"click":_vm.backButton}},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_c('i',{staticClass:"fas fa-backward"}),_vm._v(" "+_vm._s(_vm.$t('common.buttons.backButton')))])])}
var staticRenderFns = []

export { render, staticRenderFns }